<template>
  <transition name="widget-action-slide-fade">
    <div class="fts-widget-action" v-if="show">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
  }
}
</script>

<style lang="scss" scoped>
.fts-widget-action {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  box-shadow: var(--fts-elevation-1);
  background-color: inherit;
  cursor: default;
  > *:not(:last-child) {
    margin-right: 0.5rem;
  }
}
.widget-action-slide-fade-enter-active {
  transition: all .3s ease;
}
.widget-action-slide-fade-leave-active {
  transition: all .3s ease;
}
.widget-action-slide-fade-enter,
.widget-action-slide-fade-leave-to {
  transform: translateX(0.5rem);
  opacity: 0;
}
</style>